import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import MainLogo from '../../assets/MainLogo.png';
import './HomeNavbar.css';
import { Link } from 'react-router-dom';
import UserMenu from '../UI/UserMenu';

function HomeNavbar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <AppBar position="static" color="transparent" elevation={0}>
            <Container maxWidth="xl" sx={{ marginTop: '8px' }}>
                <Toolbar disableGutters>
                    <Link to='/' className='Logo'>
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                textDecoration: 'none',
                            }}
                            component={Link}
                            to={"/"}
                        >
                            <img src={MainLogo} height='90px' width='90px' />
                        </Typography>
                    </Link>
                    {/* <Box sx={{ flexGrow: 10, display: { xs: 'none', md: 'flex' } }}>
                        <div className='search-bar'>
                            <img src={SearchIcon} alt='search' style={{ padding: '5px', marginLeft: '7px', marginRight: '7px' }} />
                            <input type='text' placeholder='Search your fav domain here' name='search' />
                        </div>
                    </Box> */}
                    <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                                flexDirection: 'column',
                            }}
                            className='nav-menu'
                        >

                            <MenuItem key={'Home1'} onClick={handleCloseNavMenu}>
                                <Link to='/' className='navlink'>
                                    <Typography textAlign="center">Home</Typography>
                                </Link>
                            </MenuItem>
                            <MenuItem key={'About1'} onClick={handleCloseNavMenu}>
                                <Link to='/home' className='navlink'>
                                    <Typography textAlign="center">Roadmaps</Typography>
                                </Link>
                            </MenuItem>
                            <MenuItem key={'Contact us1'} onClick={handleCloseNavMenu}>
                                <Link to='/contact' className='navlink'>
                                    <Typography textAlign="center">Contact us</Typography>
                                </Link>
                            </MenuItem>
                            <MenuItem key='GLogin1' onClick={handleCloseNavMenu}>
                                <Link to='/login' className='navlink'>
                                    <Typography textAlign="center">Login</Typography>
                                </Link>
                            </MenuItem>
                        </Menu>
                    </Box>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                            justifyContent: 'center',
                            ml: '20px'
                        }}
                    >
                        <img src={MainLogo} height='70px' width='70px' />
                    </Typography>
                    {/* <Typography
                        variant="h5"
                        noWrap
                        sx={{
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                            justifyContent: 'center',
                        }}
                    >
                        <div className='search-bar'>
                            <img src={SearchIcon} alt='search' style={{ padding: '5px', marginLeft: '7px', marginRight: '7px' }} />
                            <input type='text' placeholder='Search your fav domain here' name='search' />
                        </div>
                    </Typography> */}
                    <Box sx={{ my: 3, flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: "flex-end", }}>
                        <Link to='/' className='navlink'>
                            <Button
                                key='Home'
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, color: '#000000a6', display: 'block', margin: '0 40px 0 40px', fontWeight: 'bolder', textTransform: 'capitalize', "&:hover": { backgroundColor: "transparent" }, fontSize: '11pt' }}
                            >
                                Home
                            </Button>
                        </Link>
                        <Link to='/home' className='navlink'>
                            <Button
                                key='About'
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, color: '#000000a6', display: 'block', margin: '0 40px 0 40px', fontWeight: 'bolder', textTransform: 'capitalize', "&:hover": { backgroundColor: "transparent" }, fontSize: '11pt' }}
                            >
                                Roadmaps
                            </Button>
                        </Link>
                        <Link to='/contact' className='navlink'>
                            <Button
                                key='Contact us'
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, color: '#000000a6', display: 'block', margin: '0 40px 0 40px', fontWeight: 'bolder', textTransform: 'capitalize', "&:hover": { backgroundColor: "transparent" }, fontSize: '11pt' }}
                            >
                                Contact us
                            </Button>
                        </Link>
                    </Box>
                    <Box sx={{ ml: 'auto' }}>
                        <UserMenu />
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );

}
export default HomeNavbar;